import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import { InputBaseComponentProps } from '@mui/material/InputBase/InputBase'

export interface StripeInputProps extends InputBaseComponentProps {
  readonly component: React.JSXElementConstructor<any>
}

const StripeInput = forwardRef(function StripeInput(
  { component: Component, ...rest }: StripeInputProps,
  ref,
) {
  const elementRef = useRef<HTMLElement>()

  useImperativeHandle(ref, () => ({
    focus: () => elementRef.current?.focus,
  }))

  return (
    <Component
      options={{
        placeholder: '',
        style: {
          base: {
            fontSize: '16px',
            '::placeholder': {
              // sometimes stripe just refuses to hide placeholder
              // even though we explicitly set empty string
              // this looks like a race condition on their end
              // so set it to transparent hoping it does not popup
              color: 'transparent',
            },
          },
        },
      }}
      onReady={(element: HTMLElement) => {
        elementRef.current = element
      }}
      {...rest}
    />
  )
})

export default StripeInput
